import { ReactComponent as BorderedLightningIcon } from "atoms/icons/bordered-lightning.svg";
import { useTranslation } from "@/core/i18n";

import { Menu, type MenuOption } from "../Menu";
import { QuickActionsMenuButton } from "./QuickActionsMenuButton";

const MenuCloseTrigger = ({ label }: { label: string }) => {
  return (
    <div className="flex items-center justify-between gap-4" data-testid="quickActionCloseTrigger">
      <span className="type-body-md font-bold">{label}</span>
      <BorderedLightningIcon />
    </div>
  );
};

type QuickActionsMenuProps = {
  options?: MenuOption[];
  disabled?: boolean;
};

export const QuickActionsMenu = ({ options, disabled = false }: QuickActionsMenuProps) => {
  const { t } = useTranslation();

  if (!options?.length) {
    return null;
  }

  const label = t("common.quickActions");

  return (
    <Menu
      disabled={disabled}
      itemsClassName="min-w-56 *:first:border-b"
      offsetCorrection={{ x: -50, y: 8 }}
      options={[{ id: "quickActions", label: <MenuCloseTrigger label={label} /> }, ...options]}
      trigger={(open) => <QuickActionsMenuButton disabled={disabled} label={label} open={open} />}
    />
  );
};
